'use client';

import { FC, useEffect, useState } from 'react';

import { NormalizedMarket, NormalizedSegment } from '@ravago/shared/page-data/models/contentful-mapped';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { groupBy } from '@ravago/utils';

import { DynamicPageLink } from '../../dynamic-page-link/dynamic-page-link';

interface Props {
   segments: Array<NormalizedSegment>;
   locale: string;
   industryBaseRoute: string;
}

interface IndustrySegments {
   industry: NormalizedMarket | null;
   segments: Array<NormalizedSegment>;
}

export const IndustriesSegment: FC<Props> = ({ segments, locale, industryBaseRoute }) => {
   const [industrySegments, setIndustrySegments] = useState<IndustrySegments[]>([]);

   useEffect(() => {
      const industryGroups = groupBy(segments, (s) => s.market?.name);
      setIndustrySegments(
         Object.entries(industryGroups).map(([_, normalizedSegments]) => ({
            industry: normalizedSegments[0].market,
            segments: normalizedSegments
         }))
      );
   }, [locale, segments]);

   return (
      <Box direction="column" gap="xs">
         {industrySegments.map((marketSegment) => (
            <Box direction="column" gap="3xs" key={marketSegment.industry?.slug}>
               <DynamicPageLink
                  id={`dynamic-link__industries-segments__${marketSegment.industry?.slug}`}
                  slug={marketSegment.industry?.slug}
                  baseRoute={{ url: industryBaseRoute, noFollow: marketSegment.industry?.seoMetadata?.noFollow }}
                  locale={locale}
               >
                  <Typography variant="body" component="span" color="primary">
                     {marketSegment?.industry?.name}
                  </Typography>
               </DynamicPageLink>
               <Typography component="p" variant="body">
                  {marketSegment.segments.map((p) => p.name).join(' • ')}
               </Typography>
            </Box>
         ))}
      </Box>
   );
};
